import React, { /*useState, useEffect,*/ useContext } from "react";
//import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Typography, Container } from "@mui/material";
import { UserContext } from "../Components/UserContext";
import RulesetView from '../Components/RulesetView.tsx';

function RulesetPage(props) {
  // Sets initial state for skill list to empty array
  //const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const rulesets = [
    {
      id: 'r_f',
      name: 'Rapido & Furioso',
      files: [
        {
          path: "R&F_D12_Regolamento.pdf",
          text: "Regolamento",
          date: "2023-01-14"
        },
        {
          path: "R&F_D12_Talenti_avanzati.pdf",
          text: "Talenti",
          date: "2021-11-29"
        },
        {
          path: "R&F_D12_Talenti_arcani.pdf",
          text: "Talenti arcani",
          date: "2024-01-27"
        },
        {
          path: "R&F_D12_Equipaggiamento.pdf",
          text: "Equipaggiamento",
          date: "2021-11-29"
        },
        {
          path: "R&F_D12_Poteri_sovrannaturali.pdf",
          text: "Poteri sovrannaturali",
          date: "2024-04-07"
        },
        {
          path: "R&F_D12_Foci_e_rituali_arcani.pdf",
          text: "Foci e rituali arcani",
          date: "2020-02-18"
        },
        {
          path: "R&F_D12_Talenti_razziali.pdf",
          text: "Talenti razziali",
          date: "2023-09-17"
        },
        {
          path: "R&F_Bestiario.pdf",
          text: "Bestiario",
          date: "2024-02-29"
        },
      ],
      images: [],
    },
    {
      id: 'r_fmod',
      name: 'Rapido & Furioso modificato',
      files: [
        {
          path: "VariazioniRegole.pdf",
          text: "Variazioni Regole",
          date: "2026-04-30"
        },
        {
          path: "Magia-Divina-base.pdf",
          text: "Magia Divina (regole base e Sfera Basilare)",
          date: "2026-04-30"
        },
        {
          path: "Magia-Arcana-base.pdf",
          text: "Magia Arcana (regole base)",
          date: "2026-05-22"
        },
        {
          path: "Disciplina_Alterazione_Materia.pdf",
          text: "Disciplina: Alterazione Materia (Magia Arcana)",
          date: "2026-04-30"
        },
        {
          path: "Disciplina_Biomanzia.pdf",
          text: "Disciplina: Biomanzia (Magia Arcana)",
          date: "2026-04-30"
        },
        {
          path: "Disciplina_Sortilegio.pdf",
          text: "Disciplina: Sortilegio (Magia Arcana)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Conoscenza.pdf",
          text: "Sfera: Conoscenza (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Elementale_Acqua.pdf",
          text: "Sfera: Elementale - Acqua (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Mentale.pdf",
          text: "Sfera: Mentale (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Morte.pdf",
          text: "Sfera: Morte (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Protezione.pdf",
          text: "Sfera: Protezione (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Tempo.pdf",
          text: "Sfera: Tempo (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Tenebre.pdf",
          text: "Sfera: Tenebre (Magia Divina)",
          date: "2026-04-30"
        },
        {
          path: "Sfera_Vita.pdf",
          text: "Sfera: Vita (Magia Divina)",
          date: "2026-04-30"
        },
      ],
      images: [],
    },
    {
      id: 'tcsf',
      name: 'Sci-Fi',
      files: [
        {
          path: "regole_base_e_talenti.pdf",
          text: "Regole Base, Abilità e Talenti",
          date: "2026-06-06"
        },
        {
          path: "combattimento.pdf",
          text: "Regole di Combattimento",
          date: "2026-06-06"
        },
        {
          path: "caratteristiche_di_ambientazione.pdf",
          text: "Caratteristiche di Ambientazione",
          date: "2026-06-06"
        },
        {
          path: "equipaggiamento.pdf",
          text: "Equipaggiamento",
          date: "2026-06-06"
        },
        {
          path: "ambientazione.pdf",
          text: "Ambientazione",
          date: "2026-06-06"
        },
        {
          path: "scheda_personaggio.pdf",
          text: "Scheda Personaggio",
          date: "2026-06-06"
        },
        {
          path: "tabelle_azioni_combattimento.pdf",
          text: "Tabelle Azioni e Combattimento",
          date: "2026-06-06"
        },
        {
          path: "tabelle_talenti.pdf",
          text: "Tabelle Talenti",
          date: "2026-06-06"
        },
        {
          path: "pandora.pdf",
          text: "Pandora I, dopo l'attacco",
          date: "2026-06-06"
        },
      ],
      images: [
        {
          path: "vector_scout_top.svg",
          text: "Vector-class scout ship, top view",
          date: "2026-06-06"
        },
        {
          path: "vector_scout_side.svg",
          text: "Vector-class scout ship, side view",
          date: "2026-06-06"
        },

      ]
    }


  ];

  let rset = rulesets.filter((el) => el.id === props.id);

  return (
    <>
      <Helmet>
        <title>{rset[0].name}</title>
      </Helmet>

      <main className="pg_container">
        <Container maxWidth="md" className="title_container">
          <Typography
            variant="h4"
            align="center"
            color="textPrimary"
            gutterBottom
          >
            {rset[0].name}
          </Typography>

        </Container>
        <Container maxWidth="lg">
           <RulesetView
            id={rset[0].id}
            name={rset[0].name}
            files={rset[0].files}
            skills={props.skills.filter((sk) => sk.ruleset === rset[0].id)}
            images={rset[0].images??[]}
            path={'/dloads/'+rset[0].id+'/'}
            cfg={props.cfg}
            wsCall={props.wsCall}
          />
        </Container>
     </main>
    </>
  );
}

export default RulesetPage;
